import Whatsapp from "../assets/wapp.svg";
import Instagram from "../assets/ig.svg";
import HeroImg from "../assets/hero-img.webp";
import "./hero.css";

export function Hero() {
  const handleWhatsAppClick = () => {
    const url = 'https://api.whatsapp.com/send?phone=5492257550272';

    if (window.gtag) {
      let opened = false;

      window.gtag('event', 'conversion', {
        send_to: 'AW-18098794923/5EEFCIuPsKUcEKvjlrZD',
        event_callback: () => {
          if (!opened) {
            opened = true;
            window.open(url, '_blank');
          }
        }
      });

      setTimeout(() => {
        if (!opened) {
          opened = true;
          window.open(url, '_blank');
        }
      }, 800);

    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <section className="hero">
      <img
        src={HeroImg}
        alt="Poda en altura"
        className="hero-bg"
        loading="eager"
        fetchPriority="high"
        width="1920"
        height="1080"
      />
      <div className=" hero-content">
        <h2>Poda y extracción de árboles</h2>
        <p>
          Trabajos profesionales, seguros y rápidos.
        </p>
        <p>Atención en el Partido de la Costa.</p>
        <div className="social-btns">

          <button
            onClick={handleWhatsAppClick}
            className="btn-primary"
          >
            <img src={Whatsapp} alt="WhatsApp" className="whatsapp-icon" />
            Contactar por WhatsApp
          </button>

          <a
            href="https://instagram.com/laestrellapoda/"
            target="_blank"
            className="btn-primary ig"
            id="instagram-btn"
          >
            <img src={Instagram} alt="Instagram" className="instagram-icon" />

            Ver nuestros trabajos
          </a>
        </div>
      </div>
    </section>
  );
}